import { twClassMerge } from '@healthhub/react-ui';
import { Typography } from 'antd';
import { useTranslation } from 'react-i18next';


export interface NoFilterResultProps {
  className?: string;
  pageName: string;
}

const { Text } = Typography;

const NoFilterResult = ({ className, pageName }: NoFilterResultProps) => {
  const { t } = useTranslation();

  return (
    <div className={twClassMerge('rounded-2xl bg-white p-4', className)}>
      <Text className="text-sm text-functional-iron">{t('noFilter.description', { pageName })}</Text>
    </div>
  );
};

export default NoFilterResult;
